<template>
  <div>
    <section
      :style="data.style ? data.style :  isDark ? 'secondary' : ''"
      :class="`${isDark ? 'secondary white--text' : ''}  ${data.class}`"
    >
      <v-container :class="`about ${ isDark ? 'white--text' : ''}`">
        <v-row justify="center" align="center">
          <v-col cols="12" md="6" lg="4" class="text-center">
            <v-text-field
              hide-details
              :dark="isDark"
              label="Title"
              @change="onChange"
              v-model="data.title"
            ></v-text-field>
          </v-col>
          <v-col cols="12" class="text-center">
            <v-row justify="center">
              <v-col cols="11" sm="10" md="8" lg="6" xl="5">
                <v-card>
                  <v-img
                    :aspect-ratio="16/9"
                    :src="data.video.thumbnail"
                    @click="$eventBus.$emit('play_video',data.video.url)"
                  >
                    <v-row class="pa-2 fill-height">
                      <v-fade-transition>
                        <v-overlay :absolute="true" :value="true" :opacity="0.2">
                          <v-btn color="primary">
                            <v-icon small>fa-play</v-icon>
                          </v-btn>
                        </v-overlay>
                      </v-fade-transition>
                    </v-row>
                  </v-img>
                </v-card>
                <v-text-field
                  @change="onChange"
                  hide-details
                  :dark="isDark"
                  label="Video Url"
                  v-model="data.video.url"
                ></v-text-field>

                <file-input
                  :dark="isDark"
                  label="Video thumbnail"
                  @change="onChange"
                  v-model="data.video.thumbnail"
                  accept="image/*"
                ></file-input>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <draggable
          tag="v-layout"
          class="row wrap justify-center align-center"
          @update="onChange"
          handle=".draggable"
          v-model="data.tiles"
        >
          <template v-for="(tile,t) in data.tiles">
            <v-col cols="11" sm="10" md="3" lg="3" xl="2" :key="t">
              <v-card :class="`${isDark ? 'secondary lighten-1 white--text' : ''}`">
                <v-card-title class="draggable py-2">
                  <v-spacer></v-spacer>
                  <v-icon :dark="isDark" class="clicky" @click="removeTile(tile)" small>fa-times</v-icon>
                </v-card-title>
                <v-divider></v-divider>
                <v-container>
                  <v-text-field
                    hide-details
                    @change="onChange"
                    :dark="isDark"
                    label="Title"
                    v-model="tile.title"
                  ></v-text-field>
                  <v-textarea
                    @change="onChange"
                    hide-details
                    :dark="isDark"
                    label="Description"
                    :rows="5"
                    v-model="tile.description"
                  ></v-textarea>
                </v-container>
              </v-card>
            </v-col>
          </template>
          <v-col cols="11" sm="10" md="3" lg="3" xl="2">
            <v-btn fab color="primary" @click="addTile">
              <v-icon>fa-plus</v-icon>
            </v-btn>
          </v-col>
        </draggable>

        <v-row justify="center">
          <v-col class="text-center" cols="12" md="6" lg="4">
            <v-text-field
              hide-details
              @change="onChange"
              :dark="isDark"
              label="Link text"
              v-model="data.link.text"
            ></v-text-field>
            <v-text-field
              hide-details
              @change="onChange"
              :dark="isDark"
              label="Link Url"
              v-model="data.link.url"
            ></v-text-field>
            <v-text-field
              hide-details
              @change="onChange"
              :dark="isDark"
              label="Link video"
              v-model="data.link.video"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-container>
    </section>
    <v-divider></v-divider>
    <v-container class="grey lighten-3">
      <v-row>
        <v-col cols="12">
          <v-switch
            label="Dark"
            dense
            @change="onChange"
            hide-details
            class="my-0 py-0"
            color="primary"
            v-model="data.dark"
          ></v-switch>
        </v-col>
        <v-col cols="12">
          <v-text-field dense label="Class" @change="onChange" v-model="data.class"></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-text-field dense label="Style" @change="onChange" v-model="data.style"></v-text-field>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import sections from "@/assets/sections.json";
import draggable from "vuedraggable";
import fileInput from "@/components/admin/file-input";

export default {
  name: "PageAboutEdit",
  props: ["value"],
  data() {
    return {};
  },
  components: {
    draggable,
    fileInput
  },
  computed: {
    data() {
      return this.value;
    },
    isDark() {
      return this.value.dark ? true : false;
    }
  },
  methods: {
    onChange() {
      this.$emit("change");
    },
    removeTile(tile) {
      if (!confirm("Remove tile ?")) {
        return;
      }

      this.data.tiles.splice(this.data.tiles.indexOf(tile), 1);
      this.onChange();
    },
    addTile() {
      let section = sections.find(s => {
        return s.type === "about";
      });

      //this.data.tiles.push({ ...section.data.tiles[0] });
      this.data.tiles.push(JSON.parse(JSON.stringify(section.data.tiles[0])));
      this.onChange();
    }
  }
};
</script>

<style lang="scss">
.about a {
  text-decoration: none;
}
.vx {
  /* Extra small devices (phones, 600px and down) */
  @media only screen and (max-width: 600px) {
    padding: 20px;
  }

  /* Small devices (portrait tablets and large phones, 600px and up) */
  @media only screen and (min-width: 600px) {
    padding: 20px;
  }

  /* Medium devices (landscape tablets, 768px and up) */
  @media only screen and (min-width: 768px) {
    padding: 10px;
  }

  /* Large devices (laptops/desktops, 992px and up) */
  @media only screen and (min-width: 992px) {
    padding: 50px;
  }

  /* Extra large devices (large laptops and desktops, 1200px and up) */
  @media only screen and (min-width: 1200px) {
    padding: 50px;
  }
}
</style>